// extracted by mini-css-extract-plugin
export default {"StatusDot":"index__StatusDot__BxVOT","active":"index__active__xpune","blocked":"index__blocked__PzpeQ"};